<template>
  <modal :name="nomeModal" classes="v--modal cbm-modal" :adaptive="true" height="auto" :maxWidth="560" :clickToClose="!salvando" @closed="aoFecharModal">
    <div class="cbm-root">
      <h3 class="cbm-title cbm-title--perigo"><fa-icon icon="ban" /> Bloquear no programa de cashback</h3>
      <p class="cbm-desc">O bloqueio vale a partir de agora e pode ser desfeito a qualquer momento.</p>

      <div v-if="clienteFixo" class="cbm-cliente">
        <div class="cbm-cliente__icone"><fa-icon icon="user" /></div>
        <div class="cbm-cliente__dados">
          <div class="cbm-cliente__nome">{{ cliente.nome || `Cliente ${cliente.clienteId}` }}</div>
          <div class="cbm-cliente__codigo">Código {{ cliente.clienteId }}</div>
        </div>
        <div v-if="cliente.saldo !== undefined && cliente.saldo !== null" class="cbm-cliente__saldo">
          <div class="cbm-cliente__saldo-rotulo">Saldo guardado</div>
          <div :class="['cbm-cliente__saldo-valor', { 'cbm-cliente__saldo-valor--zerado': !(Number(cliente.saldo) > 0) }]">{{ formatMoney(cliente.saldo) }}</div>
        </div>
      </div>

      <div v-else class="cbm-campo">
        <label class="cbm-rotulo" :for="`${nomeModal}-busca`">Cliente *</label>
        <div v-if="selecionado" class="cbm-selecionado">
          <fa-icon icon="check-circle" class="cbm-selecionado__icone" />
          <span>{{ selecionado.descricao }}</span>
          <button type="button" class="cbm-selecionado__trocar" :disabled="salvando" @click="trocarCliente">Trocar</button>
        </div>
        <template v-else>
          <div class="cbm-busca">
            <fa-icon :icon="buscando ? 'spinner' : 'search'" :spin="buscando" class="cbm-busca__icone" />
            <input
              :id="`${nomeModal}-busca`"
              ref="busca"
              v-model="busca"
              class="cbm-input"
              placeholder="Nome, código ou CNPJ"
              autocomplete="off"
              role="combobox"
              aria-autocomplete="list"
              :aria-expanded="String(opcoes.length > 0)"
              :aria-controls="`${nomeModal}-opcoes`"
              @input="buscarClientes()"
            />
          </div>
          <ul v-if="opcoes.length" :id="`${nomeModal}-opcoes`" class="cbm-opcoes" role="listbox" aria-label="Clientes encontrados">
            <li v-for="opcao in opcoes" :key="opcao.id" role="option" aria-selected="false">
              <button type="button" class="cbm-opcao" @click="selecionarCliente(opcao)">{{ opcao.descricao }}</button>
            </li>
          </ul>
          <small v-else-if="erroBusca" class="cbm-ajuda cbm-ajuda--erro" role="alert">Não foi possível buscar os clientes: {{ erroBusca }}</small>
          <small v-else-if="semResultado" class="cbm-ajuda">Nenhum cliente encontrado.</small>
          <small v-else class="cbm-ajuda">Digite ao menos 2 caracteres para buscar.</small>
        </template>
      </div>

      <div class="cbm-aviso cbm-aviso--perigo">
        <fa-icon icon="exclamation-triangle" class="cbm-aviso__icone" />
        <div>
          <strong>O que acontece com o cliente bloqueado</strong>
          <ul>
            <li>Deixa de ganhar cashback nos próximos pedidos.</li>
            <li>Não consegue usar o saldo que já tem.</li>
            <li>Não vê nada do programa nos canais de venda; só o ADM mostra o cashback dele.</li>
            <li>Reservas em orçamentos abertos são liberadas.</li>
            <li>O saldo fica guardado com o vencimento normal. Para tirá-lo, use Remover saldo.</li>
          </ul>
        </div>
      </div>

      <div class="cbm-campo">
        <label class="cbm-rotulo" :for="`${nomeModal}-motivo`">Motivo *</label>
        <textarea
          :id="`${nomeModal}-motivo`"
          v-model="motivo"
          :class="['cbm-input', 'cbm-textarea', { 'cbm-input--invalido': motivoCurto }]"
          rows="3"
          :maxlength="TAMANHO_MAXIMO_MOTIVO"
          :aria-describedby="`${nomeModal}-motivo-ajuda`"
          placeholder="Ex.: cliente com títulos em atraso recorrentes"
        ></textarea>
        <div :id="`${nomeModal}-motivo-ajuda`" class="cbm-ajuda">
          <span :class="{ 'cbm-ajuda--erro': motivoCurto }">Mínimo de {{ TAMANHO_MINIMO_MOTIVO }} caracteres. Aparece na lista de bloqueios e no extrato.</span>
          <span :class="{ 'cbm-contador--ok': !motivoCurto && motivo.trim().length > 0 }">{{ motivo.length }}/{{ TAMANHO_MAXIMO_MOTIVO }}</span>
        </div>
      </div>

      <div v-if="erro" class="cbm-erro" role="alert">
        <fa-icon icon="exclamation-triangle" class="cbm-aviso__icone" />
        <span>{{ erro }}</span>
      </div>

      <div class="cbm-footer">
        <button type="button" class="cbm-btn cbm-btn-cancel" :disabled="salvando" @click="fechar">Cancelar</button>
        <button type="button" class="cbm-btn cbm-btn-perigo" :disabled="salvando || !podeBloquear" @click="bloquear">
          <fa-icon :icon="salvando ? 'spinner' : 'ban'" :spin="salvando" /> Bloquear
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import _debounce from "lodash/debounce";
import { get, post } from "@/helpers/apiRequest";
import { DEBOUNCE_BUSCA_MS, formatMoney, mensagemErroApi } from "../helpers";
import modalVisivel from "./modalVisivel";

const TAMANHO_MINIMO_MOTIVO = 5;
const TAMANHO_MAXIMO_MOTIVO = 500;
const TAMANHO_MINIMO_BUSCA = 2;

export default {
  name: "BloquearClienteModal",
  mixins: [modalVisivel],

  props: {
    cliente: { type: Object, default: null },
  },

  data() {
    return {
      TAMANHO_MINIMO_MOTIVO,
      TAMANHO_MAXIMO_MOTIVO,
      busca: "",
      opcoes: [],
      buscando: false,
      semResultado: false,
      erroBusca: null,
      selecionado: null,
      motivo: "",
      salvando: false,
      erro: null,
    };
  },

  computed: {
    clienteFixo() {
      return !!(this.cliente && this.cliente.clienteId);
    },

    clienteId() {
      if (this.clienteFixo) return this.cliente.clienteId;

      return this.selecionado ? this.selecionado.id : null;
    },

    motivoCurto() {
      const tamanho = this.motivo.trim().length;

      return tamanho > 0 && tamanho < TAMANHO_MINIMO_MOTIVO;
    },

    podeBloquear() {
      return !!this.clienteId && this.motivo.trim().length >= TAMANHO_MINIMO_MOTIVO;
    },
  },

  methods: {
    formatMoney,

    aoAbrir() {
      Object.assign(this, { busca: "", opcoes: [], buscando: false, semResultado: false, erroBusca: null, selecionado: null, motivo: "", erro: null });
    },

    buscarClientes: _debounce(function () {
      const termo = this.busca.trim();

      this.selecionado = null;
      this.semResultado = false;
      this.erroBusca = null;

      if (termo.length < TAMANHO_MINIMO_BUSCA) {
        this.opcoes = [];

        return;
      }

      this.buscando = true;

      return get(`/admin/cashback/regras/opcoes/CLIENTE?q=${encodeURIComponent(termo)}`)
        .then((lista) => {
          if (termo !== this.busca.trim()) return;

          this.opcoes = (lista || []).map((opcao) => ({ id: opcao.chave, descricao: opcao.label }));
          this.semResultado = !this.opcoes.length;
        })
        .catch((err) => {
          if (termo !== this.busca.trim()) return;

          this.opcoes = [];
          this.erroBusca = mensagemErroApi(err);
        })
        .finally(() => {
          this.buscando = false;
        });
    }, DEBOUNCE_BUSCA_MS),

    selecionarCliente(opcao) {
      this.selecionado = opcao;
      this.opcoes = [];
    },

    trocarCliente() {
      this.selecionado = null;
      this.$nextTick(() => this.$refs.busca && this.$refs.busca.focus());
    },

    bloquear() {
      if (this.salvando) return Promise.resolve();

      this.salvando = true;
      this.erro = null;

      return post("/admin/cashback/bloqueios", { clienteId: this.clienteId, motivo: this.motivo.trim() })
        .then((json) => {
          this.$emit("bloqueado", json);
          this.$emit("update:show", false);
        })
        .catch((err) => {
          this.erro = mensagemErroApi(err);
        })
        .finally(() => {
          this.salvando = false;
        });
    },
  },
};
</script>

<style scoped src="./cashbackModal.css"></style>
<style src="./cashbackModalCaixa.css"></style>
